import { Request } from '~src/httpClient/serverApi/requests/Request';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';

export interface IDeleteSiteEncryptionKeyParams {}

export interface IDeleteSiteEncryptionKeyResult extends IResult {}

export class DeleteSiteEncryptionKeyRequest extends Request<IDeleteSiteEncryptionKeyParams, IDeleteSiteEncryptionKeyResult> {
  constructor(params: IDeleteSiteEncryptionKeyParams) {
    super('deleteSiteEncryptionKey', params);
  }
}